import date_interval from './dates_intervals';
export default {
  lineDataTransformCanvasJS(graph_data, type_graph, name){
    var graph_array=[];
    for(var i=0; i<graph_data.length; i++){
      graph_data[i].dateTime = date_interval.correctDateTimeRawAPI(graph_data[i].dateTime);
      if(i===0){
        if(graph_data[i].field.length>1){
          for(var c=0;c<graph_data[i].field.length; c++){
            graph_array.push({"type": type_graph,xValueFormatString: 'DD/MM HH:mm',showInLegend: true,name: name[c],"dataPoints":[{"x":new Date(graph_data[i].dateTime[4]+graph_data[i].dateTime[5]+graph_data[i].dateTime[6]+graph_data[i].dateTime[7], parseInt(graph_data[i].dateTime[2]+graph_data[i].dateTime[3])-1, parseInt(graph_data[i].dateTime[0]+graph_data[i].dateTime[1]), parseInt(graph_data[i].dateTime[8]+graph_data[i].dateTime[9]), graph_data[i].dateTime[10]+graph_data[i].dateTime[11]),"y":Math.round(graph_data[i].field[c].value*100)/100}]});
          }
        }else{
          graph_array.push({"type": type_graph,xValueFormatString: 'DD/MM HH:mm',showInLegend: true,name:name[0],"dataPoints":[{"x":new Date(graph_data[i].dateTime[4]+graph_data[i].dateTime[5]+graph_data[i].dateTime[6]+graph_data[i].dateTime[7], parseInt(graph_data[i].dateTime[2]+graph_data[i].dateTime[3])-1, parseInt(graph_data[i].dateTime[0]+graph_data[i].dateTime[1]), parseInt(graph_data[i].dateTime[8]+graph_data[i].dateTime[9]), graph_data[i].dateTime[10]+graph_data[i].dateTime[11]),"y":Math.round(graph_data[i].field.value*100)/100}]});
        }
      }else {
        if(graph_data[i].field.length>1){
          for(var c=0;c<graph_data[i].field.length; c++){
            graph_array[c].dataPoints.push({"x":new Date(graph_data[i].dateTime[4]+graph_data[i].dateTime[5]+graph_data[i].dateTime[6]+graph_data[i].dateTime[7], parseInt(graph_data[i].dateTime[2]+graph_data[i].dateTime[3])-1, parseInt(graph_data[i].dateTime[0]+graph_data[i].dateTime[1]), parseInt(graph_data[i].dateTime[8]+graph_data[i].dateTime[9]), graph_data[i].dateTime[10]+graph_data[i].dateTime[11]),"y":Math.round(graph_data[i].field[c].value*100)/100});
          }
        }else{
          graph_array[0].dataPoints.push({"x":new Date(graph_data[i].dateTime[4]+graph_data[i].dateTime[5]+graph_data[i].dateTime[6]+graph_data[i].dateTime[7], parseInt(graph_data[i].dateTime[2]+graph_data[i].dateTime[3])-1, parseInt(graph_data[i].dateTime[0]+graph_data[i].dateTime[1]), parseInt(graph_data[i].dateTime[8]+graph_data[i].dateTime[9]), graph_data[i].dateTime[10]+graph_data[i].dateTime[11]),"y":Math.round(graph_data[i].field.value*100)/100});
        }
      }
    }
    return graph_array;
  },
  dataTransYearlyFormCanvasJS(graph_data, type_graph, name){
    var graph_array=[];
    var month=parseInt(graph_data[0].dateTime[2]+graph_data[0].dateTime[3]);
    var lecture=parseFloat(graph_data[0].field.value);

    for(var i=1; i<graph_data.length; i++) {
      if(parseInt(graph_data[i].dateTime[2]+graph_data[i].dateTime[3])!==month){
        if(graph_array.length===0){
          graph_array.push({"type": type_graph,xValueFormatString: 'MM/YYYY', showInLegend: false, name:name[0], color: "blue", "dataPoints":[{"x":new Date(graph_data[i].dateTime[4]+graph_data[i].dateTime[5]+graph_data[i].dateTime[6]+graph_data[i].dateTime[7], parseInt(graph_data[i].dateTime[2]+graph_data[i].dateTime[3])-1), "y":Math.round((parseFloat(graph_data[i].field.value)-lecture)*100)/100}]});
          month = parseInt(graph_data[i].dateTime[2]+graph_data[i].dateTime[3]);
          lecture = parseFloat(graph_data[i].field.value);
        }else{
          graph_array[0].dataPoints.push({"x":new Date(graph_data[i].dateTime[4]+graph_data[i].dateTime[5]+graph_data[i].dateTime[6]+graph_data[i].dateTime[7], parseInt(graph_data[i].dateTime[2]+graph_data[i].dateTime[3])-1),"y":Math.round((parseFloat(graph_data[i].field.value)-lecture)*100)/100});
          month = parseInt(graph_data[i].dateTime[2]+graph_data[i].dateTime[3]);
          lecture = parseFloat(graph_data[i].field.value);
        }
      }
    }

    return graph_array;
  }
}



// WEBPACK FOOTER //
// ./src/utilities/data_transformers.js